import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
const pricingTiers = [{
  id: 1,
  name: "Essentials",
  description: "Perfect for small teams starting their migration journey",
  price: "$7,500",
  currency: "CAD",
  isPopular: false,
  features: ["Data mapping and validation", "Basic report templates", "Email support", "30-day post-migration support"]
}, {
  id: 2,
  name: "Professional",
  description: "Most popular choice for mid-sized businesses",
  price: "$12,500",
  currency: "CAD",
  isPopular: true,
  features: ["Everything in Essentials", "Custom report branding", "Audit-ready documentation", "Priority email & phone support", "90-day post-migration support", "Training session included"]
}, {
  id: 3,
  name: "Enterprise",
  description: "Comprehensive migration for complex operations",
  price: "$25,000",
  currency: "CAD",
  isPopular: false,
  features: ["Everything in Professional", "Dedicated migration specialist", "Custom workflow integration", "Advanced data transformation", "24/7 priority support", "6-month post-migration support", "Multiple training sessions"]
}];
export default function ScalablePricingTiers() {
  return <section className="relative bg-muted-dark py-16 lg:py-24">
      <div className="container mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center mb-12 animate-fade-in-up">
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-white mb-4">
            Scalable Pricing Tiers
          </h2>
          <p className="text-lg text-white/80 leading-relaxed">
            Transparent pricing in Canadian dollars for your Microsoft Dynamics
            GP to Business Central migration. Choose the package that fits your
            business needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {pricingTiers.map((tier, i) => <Card key={tier.id} data-index={i} className={`relative bg-white/5 backdrop-blur-sm border-white/10 shadow-strong hover:shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] animate-fade-in-up-delay-${i * 100} ${tier.isPopular ? "ring-2 ring-accent" : ""}`}>
              {tier.isPopular && <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <Badge variant="default" className="bg-accent text-white px-4 py-1 shadow-medium">
                    Most Popular
                  </Badge>
                </div>}

              <CardHeader className="border-b border-white/10 pb-6">
                <CardTitle className="text-2xl text-white">
                  {tier.name}
                </CardTitle>
                <CardDescription className="text-white/70 mt-2">
                  {tier.description}
                </CardDescription>
              </CardHeader>

              <CardContent className="pt-6">
                <div className="mb-6">
                  <div className="flex items-baseline gap-2">
                    <span className="text-4xl font-bold text-white">
                      {tier.price}
                    </span>
                    <span className="text-white/60 text-sm font-medium">
                      {tier.currency}
                    </span>
                  </div>
                </div>

                <ul className="space-y-3">
                  {tier.features.map((feature, index) => <li key={index} data-index={index} className="flex items-start gap-3 text-white/80">
                      <Check className="size-5 text-secondary shrink-0 mt-0.5" />
                      <span className="text-sm leading-relaxed">{feature}</span>
                    </li>)}
                </ul>
              </CardContent>

              <CardFooter className="pt-6 border-t border-white/10">
                <Button asChild variant={tier.isPopular ? "default" : "outline"} className={`w-full ${tier.isPopular ? "bg-accent hover:bg-accent/90 text-white" : "bg-white/10 text-white border-white/20 hover:bg-white/20"}`}>
                  <Link to="/ContactPage">Get Started</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>

        <div className="mt-12 text-center animate-fade-in-up-delay-200">
          <p className="text-white/70 text-sm mb-4">
            All packages include audit-ready reporting and branded outputs.
            Need a custom solution?
          </p>
          <Button asChild variant="outline" className="bg-white/10 text-white border-white/20 hover:bg-white/20">
            <Link to="/ContactPage">Contact Our Team</Link>
          </Button>
        </div>
      </div>
    </section>;
}